<template>
  <div class="raceIntroduction">
    <div class="navbar-dark">
      <div class="container">
        <el-form
          ref="ruleForm"
          :rules="ruleRules"
          :model="form"
          :label-position="lablePosition"
          label-width="130px"
        >
          <el-form-item label="选择赛区" prop="divisionId">
            <el-select
              v-model="form.divisionId"
              placeholder="请选择赛区"
              @change="selectGet"
            >
              <el-option
                v-for="item in divisions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择地区" prop="provinceId">
            <el-select
              v-model="form.provinceId"
              placeholder="省"
              @change="getArea(2, form.provinceId)"
              style="width: 32%"
            >
              <el-option
                v-for="item in provOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <el-select
              v-model="form.cityId"
              placeholder="市"
              @change="getArea(3, form.cityId)"
              style="width: 32%"
            >
              <el-option
                v-for="item in cityOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <el-select
              v-model="form.districtId"
              placeholder="县"
              style="width: 33%"
            >
              <el-option
                v-for="item in countyOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="团队名称" prop="teamName">
            <el-input
              v-model="form.teamName"
              placeholder="请输入团队名称"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="选择组别" prop="groupId">
            <el-select v-model="form.groupId" placeholder="请选择组别">
              <el-option
                v-for="item in grounds"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>-->
          <div
            style="
              color: #5088f4;
              font-size: 24px;
              text-align: left;
              margin-bottom: 20px;
            "
          >
            队长信息
          </div>
          <el-form-item
            label="队长姓名"
            :prop="'items.0.userName'"
            :rules="[
              { required: true, message: '请输入队长信息', trigger: 'blur' },
            ]"
          >
            <el-input
              v-model="form.items[0].userName"
              placeholder="请输入队长信息"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="队长性别"
            :prop="'items.0.userSex'"
            :rules="[
              { required: true, message: '请选队长择性别', trigger: 'change' },
            ]"
          >
            <!-- <el-select v-model="form.items[0].sex" placeholder="请选队长择性别">
              <el-option label="男" :value="0"></el-option>
              <el-option label="女" :value="1"></el-option>
            </el-select>-->
            <el-radio-group v-model="form.items[0].userSex">
              <el-radio :label="0 + ''">男</el-radio>
              <el-radio :label="1 + ''">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="联系电话"
            :prop="'items.0.phoneNumber'"
            :rules="moreRules.mobile"
          >
            <el-input
              v-model="form.items[0].phoneNumber"
              placeholder="请输入队长联系电话"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="所在学校"
            :prop="'items.0.workUnit'"
            :rules="[
              {
                required: true,
                message: '请输入队长所在学校',
                trigger: 'blur',
              },
            ]"
          >
            <el-input
              v-model="form.items[0].workUnit"
              placeholder="请输入队长所在学校"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="所属年级"
            :prop="'items.0.duty'"
            :rules="[
              {
                required: true,
                message: '请输入队长所属年级',
                trigger: 'blur',
              },
            ]"
          >
            <el-input
              v-model="form.items[0].duty"
              placeholder="请输入队长所属年级"
            ></el-input>
          </el-form-item>
          <div
            style="
              color: #5088f4;
              font-size: 24px;
              text-align: left;
              margin-bottom: 20px;
            "
          >
            队伍信息 &nbsp;&nbsp;
            <i
              class="el-icon-circle-plus-outline"
              @click="addItem"
              v-if="form.items.length == 1"
            ></i>
          </div>
          <el-row v-for="(item, index) in form.items" :key="index">
            <div v-if="index > 0">
              <el-form-item
                :label="'队员' + index + '姓名'"
                :prop="'items.' + index + '.userName'"
                :rules="[
                  {
                    required: true,
                    message: '请输入队员姓名',
                    trigger: 'change',
                  },
                ]"
              >
                <el-input
                  v-model="form.items[index].userName"
                  placeholder="请输入队员姓名"
                ></el-input>
              </el-form-item>
              <el-form-item
                :label="'队员' + index + '性别'"
                :prop="'items.' + index + '.userSex'"
                :rules="[
                  {
                    required: true,
                    message: '请选择队员性别',
                    trigger: 'change',
                  },
                ]"
              >
                <!-- <el-select v-model="form.items[index].sex" placeholder="请选择队员性别">
                  <el-option label="男" :value="0"></el-option>
                  <el-option label="女" :value="1"></el-option>
                </el-select>-->
                <el-radio-group v-model="form.items[index].userSex">
                  <el-radio :label="0 + ''">男</el-radio>
                  <el-radio :label="1 + ''">女</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                :label="'队员' + index + '联系电话'"
                :prop="'items.' + index + '.phoneNumber'"
                :rules="moreRules.mobile"
              >
                <el-input
                  v-model="form.items[index].phoneNumber"
                  placeholder="请输入队员联系电话"
                ></el-input>
              </el-form-item>
              <el-form-item
                :label="'队员' + index + '所在学校'"
                :prop="'items.' + index + '.workUnit'"
                :rules="[
                  {
                    required: true,
                    message: '请输入队员所在学校',
                    trigger: 'change',
                  },
                ]"
              >
                <el-input
                  v-model="form.items[index].workUnit"
                  placeholder="请输入队员所在学校"
                ></el-input>
              </el-form-item>
              <el-form-item
                :label="'队员' + index + '所属年级'"
                :prop="'items.' + index + '.duty'"
                :rules="[
                  {
                    required: true,
                    message: '请输入队员所属年级',
                    trigger: 'change',
                  },
                ]"
              >
                <el-input
                  v-model="form.items[index].duty"
                  placeholder="请输入队员所属年级"
                ></el-input>
              </el-form-item>
              <el-button v-if="index != 0" @click="del(index)">删除</el-button>
              <hr />
            </div>
          </el-row>
          <div
            style="
              color: #5088f4;
              font-size: 24px;
              text-align: left;
              margin-bottom: 20px;
            "
          >
            学校指导老师
          </div>
          <el-form-item label="姓名" prop="schoolAdviser">
            <el-input
              v-model="form.schoolAdviser"
              placeholder="请输入学校指导老师姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="schoolSex">
            <!-- <el-select v-model="form.schoolSex" placeholder="请选择学校指导老师性别">
              <el-option label="男" value="0"></el-option>
              <el-option label="女" value="1"></el-option>
            </el-select>-->
            <el-radio-group v-model="form.schoolSex">
              <el-radio :label="0 + ''">男</el-radio>
              <el-radio :label="1 + ''">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="联系电话" prop="schoolMobile">
            <el-input
              v-model="form.schoolMobile"
              placeholder="请输入学校指导老师联系电话"
            ></el-input>
          </el-form-item>
          <el-form-item label="所在单位" prop="schoolUnit">
            <el-input
              v-model="form.schoolUnit"
              placeholder="请输入学校指导老师所在单位"
            ></el-input>
          </el-form-item>
          <el-form-item style="text-align: center" label-width="0px">
            <el-checkbox v-model="checked">我已阅读且同意</el-checkbox>
            <span
              @click="dataSourceVisible = !dataSourceVisible"
              style="color: #409eff; cursor: pointer"
              >《参赛须知》</span
            >
          </el-form-item>
          <el-form-item style="text-align: center" label-width="0px">
            <el-button type="primary" @click="onSubmit">提交报名信息</el-button>
          </el-form-item>
        </el-form>
      </div>

      <el-dialog
        :visible.sync="dataSourceVisible"
        title="参赛须知"
        width="50%"
        v-if="content"
      >
        <span v-html="content"></span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dataSourceVisible = false">取 消</el-button>
          <el-button type="primary" @click="dataSourceVisible = false"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import ChildLogo from '@/components/ChildLogo.vue'

export default {
  components: {
    ChildLogo: ChildLogo
  },
  data () {
    // 电话验证
    const validatePhone = (rule, value, callback) => {
      // 定义规则
      let reg = /^1[3456789]\d{9}$/
      if (value !== '' && reg.test(value)) {
        callback()
      } else {
        callback(new Error('请输入正确的手机号'))
      }
    }
    return {
      activeName: 'first',
      form: {
        contParticipantMember: {},
        items: [{}],
        schoolSex: '0'
      },
      dataSourceVisible: false,
      provOptions: [], // 省下拉
      cityOptions: [], // 市
      countyOptions: [], // 县
      divisions: [], // 赛区
      grounds: [], // 组别
      checked: false, // 是否已阅读
      // 删除对象
      ids: [],
      content: '',
      ruleRules: {
        divisionId: [
          { required: true, message: '请选择赛区', trigger: 'change' }
        ],
        provinceId: [
          { required: true, message: '请选择地区', trigger: 'change' }
        ],
        teamName: [
          { required: true, message: '请输入团队名称', trigger: 'blur' }
        ],
        groupId: [{ required: true, message: '请选择组别', trigger: 'change' }],
        schoolAdviser: [
          {
            required: true,
            message: '请输入学校指导老师姓名',
            trigger: 'blur'
          }
        ],
        schoolSex: [
          {
            required: true,
            message: '请选择学校指导老师性别',
            trigger: 'change'
          }
        ],
        schoolMobile: [
          {
            required: true,
            message: '请输入学校指导老师联系电话',
            trigger: 'change'
          },
          {
            validator: validatePhone,
            trigger: 'change'
          }
        ],
        schoolUnit: [
          {
            required: true,
            message: '请输入学校指导老师所在单位',
            trigger: 'blur'
          }
        ]
      },
      // 新增表单的验证规则
      moreRules: {
        mobile: [
          { required: true, message: '请输入联系电话', trigger: 'change' },
          {
            validator: validatePhone,
            trigger: 'change'
          }
        ]
      },
      lablePosition: 'right'
    }
  },
  beforeMount () {
    // 添加判断方法
    let mobile = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
    if (mobile) {
      this.lablePosition = 'top'
    }
  },
  created () {
    // 个人信息保密承诺书
    this.axios.get(this.siteURL + '/actuator/data/27', {}).then((res) => {
      if (res.data.code === 200) {
        this.content = res.data.data.content
      } else {
        this.$message(res.data.msg)
      }
    })
  },
  mounted () {
    // 获取省市县信息
    this.getArea(1, null)
    // 获取赛区信息
    this.getDivision()
    // 获取组别信息
    this.getGroup()

    if (!this.$store.state.user) {
      this.$store.commit('competitionMutations', true)
    } else {
      this.getSignUpByUser()
    }
  },
  methods: {
    handleClick (tab, event) {
      console.log(tab, event)
    },
    addItem () {
      this.form.items.push({})
    },
    del (index) {
      var params = this.form.items[index]
      this.ids.push(params.id)
      this.$confirm('是否删除' + params.userName + '的数据项?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(this.form.items.splice(index, 1))
        .catch(function () {})
    },
    getArea (type, parentId) {
      var parentId = parentId != null ? '&parentId=' + parentId : ''
      var api =
        this.systemURL + '/actuator/area/list?levelType=' + type + parentId
      if (type === 1) {
        this.form.cityId = ''
      }
      this.axios.get(api, {}).then((res) => {
        if (type === 1) {
          this.provOptions = res.data.rows
        } else if (type === 2) {
          this.cityOptions = res.data.rows
        } else if (type === 3) {
          this.countyOptions = res.data.rows
        }
      })
    },
    // 赛区改变  地区自动选择
    selectGet (vId) {
      let obj = this.divisions.find((item) => {
        // 数据源
        return item.id === vId // 筛选出匹配数据
      })
      let string = obj.name
      for (let i = 0; i < this.provOptions.length; i++) {
        if (string === '新疆赛区') {
          if (this.provOptions[i].name === '新疆维吾尔自治区') {
            this.form.provinceId = this.provOptions[i].id
            return
          }
        }
        if (string.substring(0, 4) === '新疆建设') {
          if (this.provOptions[i].name.substring(0, 4) === '新疆建设') {
            this.form.provinceId = this.provOptions[i].id
            return
          }
        }
        if (this.provOptions[i].name.substring(0, 2) === string.substring(0, 2)) {
          this.form.provinceId = this.provOptions[i].id
        }
      }
    },
    // 获取赛区信息
    getDivision () {
      var api = this.baseURL + '/actuator/division/list'
      this.axios.get(api, {}).then((res) => {
        this.divisions = res.data.rows
      })
    },
    // 获取组别信息
    getGroup () {
      var api = this.siteURL + '/actuator/child/getChildByType/Group'
      this.axios.get(api, {}).then((res) => {
        this.grounds = res.data.data
      })
    },
    onSubmit () {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (!this.checked) {
            this.$message('请阅读并同意《参赛须知》')
            return
          }
          let userId = this.$store.state.user.userId
          if (!userId) {
            this.$store.commit('loginVisibleMutations', true)
            return
          }
          var api = this.baseURL + '/actuator/participant'
          this.form.siteId = this.siteId
          this.form.userId = userId
          var params = this.form
          this.axios
            .post(api, params)
            .then((res) => {
              if (res.data.code === 200) {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                })
                this.$router.push({
                  path: '/myHome',
                  query: { articleId: '2' }
                })
                this.$router.go(0)
              } else {
                this.$message(res.data.msg)
              }
            })
            .catch(() => {
              this.$message({
                message: '保存失败',
                type: 'error'
              })
            })
        }
      })
    },
    getSignUpByUser () {
      let userId = this.$store.state.user.userId
      var api =
        this.baseURL +
        `/actuator/participant/list?userId=${userId}&siteId=${this.siteId}`
      this.axios.get(api, {}).then((res) => {
        if (res.data.rows.length === 1) {
          this.getArea(2, res.data.rows[0].provinceId)
          this.getArea(3, res.data.rows[0].cityId)
          this.form = res.data.rows[0]
        }
      })
    }
  }
}
</script>

<style scoped>
.expertName {
  display: inline-block;
  text-align: left;
  width: 50%;
  color: #0654ef;
  font-size: 36px;
  padding-left: 20px;
}

.introduction {
  text-align: left;
  padding: 20px;
  text-indent: 2em;
}

.sigma-content {
  margin: 40px 0 10px;
  text-align: center;
  background-color: #fff;
}
.sigma-middle-line:before {
  content: "";
  display: block;
  height: 1px;
  width: 100%;
  background-color: #0654ef; /*颜色需与bai主题大背景du色一致zhi*/
  position: relative;
  top: 25px; /*调节线高*/
  left: 0;
}
.sigma-line-text {
  display: inline-block;
  background: #fff;
  padding: 0 18px 0 18px;
  position: relative;
  font-size: 28px;
  font-weight: 500;
  color: #0654ef;
}

.firstLevel {
  text-align: left;
  font-weight: bold;
}

.raceIntroduction .el-form-item__content > div {
  width: 100%;
}
.el-form-item__content .el-button--primary {
  width: 25% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/SignUpModule.vue